import { store } from "../store/index.js";
import router from "../router";

async function checkNotifiche(to, from) {
    /* Se il token nel localStorage è nullo vuol dire che sono
     * nella procedura di logout, quindi non è il caso di mandare
     * la chiamata delle notifiche. */
    if (localStorage.getItem("user_token") == null) {
        return;
    }

    if (from.name != "Notifica") {
        var request = {
            controller: "Notifiche",
            method: "POST",
            richiesta: {
                action: "getnotifichemoduli",
                token: localStorage.getItem("user_token"),
            },
        };

        const overlay_on = new CustomEvent("overlay_on", {
            detail: null,
        });

        const overlay_off = new CustomEvent("overlay_off", {
            detail: null,
        });

        if (document.getElementById("inspire_main")) {
            document.getElementById("inspire_main").dispatchEvent(overlay_on);
        }
        store.dispatch("api", request).then((res) => {
            if (document.getElementById("inspire_main")) {
                document.getElementById("inspire_main").dispatchEvent(overlay_off);
            }

            var notifiche = [];
            for (const e of res.data.result) {
                if (e.path_menu == to.fullPath || (e.id_modulo == -1 && from.fullPath == "/login")) {
                    notifiche.push(e);
                }
            }

            if (notifiche.length > 0) {
                router.push({
                    name: "Notifica",
                    params: { notifiche: notifiche, originalpath: to.fullPath },
                });
            }
        }).catch(err => {
            if (document.getElementById("inspire_main")) {
                document.getElementById("inspire_main").dispatchEvent(overlay_off);
            }

            console.error(err);
        });
    }
}

export { checkNotifiche };
